// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3iTrU","col":"styles_col__11Wwz"};